import React, { Component } from 'react';
import Text, { H4 } from '@dbk/ui-text';
import callbackOptions from '../../../data/callbackoptions.json';
import './rm-callback-styles.css';
import { Radio } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';

class RmCallBack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      selectedStates: [],
      warningMsg: false,
      displayMsg: '',
      loadingFlag: false,
      rmModal: false,
    };
    this.renderrmCallbackOptions = this.renderrmCallbackOptions.bind(this);
    this.submitRequest = this.submitRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderTabletAssetItem = this.renderTabletAssetItem.bind(this);
    this.deselectAll = this.deselectAll.bind(this);
    this.closeRMCallBack = this.closeRMCallBack.bind(this);
  }
  componentWillMount() {
    this.deselectAll();
  }

  closeRMCallBack() {
    this.deselectAll();
    this.setState({
      isChecked: false,
      selectedStates: [],
      warningMsg: false,
      displayMsg: '',
      loadingFlag: false,
      rmModal: false,
    });
    this.props.onChange();
  }

  submitRequest() {
    const { selectedStates, warningMsg } = this.state;
    const {
      i18n: { messages },
      edelivery: { showPrompt },
      ui: { history },
    } = this.props;
    this.setState({ loadingFlag: true });
    var currentScreen = '',
      screenName = '';
    if (history.currentLocation.pathname.substring(24) != 'null') {
      screenName = history.currentLocation.pathname;
      if (screenName.includes('portfolio')) {
        currentScreen = 'app.common.pageTitle.portfolio';
      } else if (screenName.includes('income')) {
        currentScreen = 'app.common.pageTitle.incExp';
      } else if (screenName.includes('transactions')) {
        currentScreen = 'app.common.pageTitle.transactions';
      } else if (screenName.includes('maturities')) {
        currentScreen = 'app.common.pageTitle.maturities';
      } else if (screenName.includes('insights')) {
        currentScreen = 'app.common.pageTitle.insights';
      } else if (screenName.includes('profile')) {
        currentScreen = 'app.common.pageTitle.profile';
      } else if (screenName.includes('reports')) {
        currentScreen = 'app.common.pageTitle.reports';
      } else if (screenName.includes('downloads')) {
        currentScreen = 'app.common.downloads';
      } else {
        currentScreen = 'app.common.pageTitle.portfolio';
      }
    } else {
      currentScreen = history.currentLocation.pathname.substring(13, 23);
    }
    let input = {
      screen: messages[currentScreen],
      context: messages[selectedStates[0].title],
    };

    if (
      showPrompt == 2 &&
      messages[selectedStates[0].title] == messages['app.rmcallback.eDelivery']
    ) {
      this.props.edelivery.updateUserPreference();
      this.props.edelivery
        .saveUserPreferences('edelivery-1', input.screen)
        .then((success) => {
          this.setState({ rmModal: true, loadingFlag: false });
        });
    } else {
      this.props.sendRMCallBack({ input }).then((success) => {
        this.setState({ rmModal: true, loadingFlag: false });
      });
    }
  }

  deselectAll() {
    let getList = callbackOptions.options;
    getList.forEach(function(item, k) {
      item.isChecked = false;
    });
  }

  handleChange(e, asset) {
    this.deselectAll();
    let arrayList = callbackOptions.options;
    let checkedCountTemp = 0;
    let selectedOptions = [];
    this.setState({
      selectedStates: selectedOptions,
      isChecked: true,
    });

    arrayList.forEach(function(dataRow, i) {
      if (dataRow.key == asset.key) {
        dataRow.isChecked = true;
        selectedOptions.push(dataRow);
      }
    });
    this.setState({
      selectedStates: selectedOptions,
    });
  }

  renderTabletAssetItem(asset) {
    const { title, isChecked, key } = asset;
    const { i18n: { messages } } = this.props;
    return (
      <div className="rmcallback-seperator">
        <div
          onClick={(e) => this.handleChange(e, asset)}
          className={'margin-5'}
        >
          <span className={'margin-left-15'}>
            <Radio
              checked={isChecked}
              onChange={(e) => this.handleChange(e, asset)}
              name="consolidated_portfoilo"
              value="value"
              id="consolidated_portfoilo"
            />
          </span>
          <span className="margin-left-10">
            <span>
              <Text secondary={isChecked ? true : false}>
                {messages[title]}
              </Text>
            </span>
          </span>
        </div>
      </div>
    );
  }

  renderrmCallbackOptions() {
    const options = callbackOptions.options;
    const optionLength = options.size;
    if (options != undefined && options != null) {
      return (
        <div className="row">
          <div className="block-item">
            {options.map((item, index) => {
              return <div key={index}>{this.renderTabletAssetItem(item)}</div>;
            })}
          </div>
        </div>
      );
    }
  }

  render() {
    const {
      isChecked,
      selectedStates,
      warningMsg,
      loadingFlag,
      rmModal,
    } = this.state;
    const { i18n: { messages } } = this.props;
    const { displayMsg, success } = this.props.callback;
    const eDeliverySuccess =
      selectedStates[0] && selectedStates[0].key
        ? selectedStates[0].key === 'edelivery' &&
          displayMsg === messages['app.rmcallback.successMsg']
        : false;

    return (
      <div>
        {!rmModal && (
          <div className="rmcallback-modal">
            <div className="margin-bottom-10">
              <H4 className="rmcallback-title">
                {messages['app.rmcallback.header']}
              </H4>
            </div>
            <div className="rmcallback-seperator">
              <H4 className="rmcallback-title">
                {messages['app.rmcallback.subTitle']}
              </H4>
            </div>
            <div>{this.renderrmCallbackOptions()}</div>
            <div className={'text-align-right'}>
              <Button
                loading={loadingFlag ? true : false}
                disabled={!isChecked ? true : false}
                className={'margin-top-40'}
                onClick={() => this.submitRequest()}
              >
                {messages['app.rmcallback.subReq']}
              </Button>
            </div>
          </div>
        )}
        {rmModal && (
          <div className="popup">
            <div className="starrating-container">
              <div className="rmcallback-response">
                <div className="text-center margin-bottom-30">
                  {success || eDeliverySuccess ? (
                    <span>{messages['app.rmcallback.reqSub']}</span>
                  ) : (
                    <span />
                  )}
                </div>
                <div className="text-center message-text">
                  <span>{displayMsg}</span>
                </div>
                <div className="text-center">
                  <div className="margin-top-100">
                    <div style={{ width: 200, margin: '0 auto' }}>
                      <Button onClick={() => this.closeRMCallBack()}>
                        {messages['app.rmcallback.okMsg']}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RmCallBack;
